import { Component, OnDestroy } from '@angular/core';
import { ModalOverlayRef } from '@core/classes/modal-overlay.ref';
import { Currency, DataTypeOptions, getCurrencyKey } from '@core/constants/data-types.constants';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { FinancialInfo, RatingsState } from '@redux/reducers';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mfp-financial-info',
  templateUrl: './financial-info.component.html',
  styleUrls: ['./financial-info.component.scss']
})
export class FinancialInfoComponent implements OnDestroy {
  financialInfoData!: FinancialInfo;
  ratings!: RatingsState;

  $storeSubscription: Subscription;
  currencyOptions: DataTypeOptions<Currency> = [];
  getCurrencyKey = getCurrencyKey;

  constructor(public dialogRef: ModalOverlayRef, private store: Store<AppState>) {
    this.$storeSubscription = this.store.subscribe({
      next: state => {
        this.financialInfoData = state.financialInfo;
        this.ratings = state.ratings;
        this.currencyOptions = state.config.currencies;
      }
    });
  }

  ngOnDestroy() {
    this.$storeSubscription.unsubscribe();
  }

  close() {
    this.dialogRef.close();
  }
}
